import { AuthEventAction, AuthEventStatus, UserLoginInfo } from '@/helpers/Authentication/types';
import { convertListingTypeToValuesForTracking } from '@/helpers/GTM/GTMHelper';
import {
  EventLocation,
  InteractionContainerName,
  InteractionEvent,
  InteractionGoal,
} from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { HgListingCardSize } from '@smg-real-estate/domus';
import { ListingItem } from '@smg-real-estate/hg-search-libs';

// NOTE: convert HgListingCardSize to string for tracking
export function mapCardSizeTracking(listingCardSize: HgListingCardSize): string {
  return Object.keys(HgListingCardSize)[Object.values(HgListingCardSize).indexOf(listingCardSize)];
}

export interface TrackFavouriteSaveParams {
  interactionContainer: InteractionContainerName.PDP;
  listingId: string;
  listingItem: ListingItem;
}

export function trackFavouriteSave(params: TrackFavouriteSaveParams): void {
  const { interactionContainer, listingId, listingItem } = params;
  trackEventHarmonized(InteractionEvent.FAVOURITES_ADD, {
    h_event_category_006: InteractionEvent.FAVOURITES_ADD,
    h_event_action_007: InteractionGoal.ADD_TO_FAVOURITES,
    h_event_label_008: interactionContainer,
    h_listing_advertisement_id_120: listingId,
    h_listing_lister_id_154: listingItem?.listing?.lister?.id,
    h_list_item_vas_090: convertListingTypeToValuesForTracking(listingItem?.listingType?.type),
  });
}

export function trackFavouriteRemove(
  InteractionContainer: InteractionContainerName.PDP,
  listingId: string,
): void {
  trackEventHarmonized(InteractionEvent.FAVOURITES_REMOVE, {
    h_event_category_006: InteractionEvent.FAVOURITES_REMOVE,
    h_event_action_007: InteractionGoal.REMOVE_FROM_FAVOURITES,
    h_event_label_008: InteractionContainer,
    h_listing_advertisement_id_120: listingId,
  });
}

export function trackFavouriteAddTry(
  InteractionContainer: InteractionContainerName.PDP,
  listingId: string,
): void {
  trackEventHarmonized(InteractionEvent.FAVOURITES_ADD, {
    h_event_category_006: InteractionEvent.FAVOURITES_ADD,
    h_event_action_007: InteractionGoal.ADD_FAVOURITES_TRY,
    h_event_label_008: InteractionEvent.FAVOURITES_ADD,
    h_listing_advertisement_id_120: listingId,
  });
}

export function trackFavouriteSignInButton(listingId: string): void {
  trackEventHarmonized(InteractionEvent.BUTTON_CLICK, {
    h_event_category_006: InteractionEvent.BUTTON_CLICK,
    h_event_action_007: InteractionGoal.GO_TO_LOGIN,
    h_event_label_008: InteractionEvent.FAVOURITES_ADD,
    h_listing_advertisement_id_120: listingId,
  });
}

export function trackFavouriteRegisterAccountButton(listingId: string): void {
  trackEventHarmonized(InteractionEvent.BUTTON_CLICK, {
    h_event_category_006: InteractionEvent.BUTTON_CLICK,
    h_event_action_007: InteractionGoal.REGISTER_ACCOUNT,
    h_event_label_008: InteractionEvent.FAVOURITES_ADD,
    h_listing_advertisement_id_120: listingId,
  });
}

export function trackLoginRequireDisplay(listingId: string): void {
  trackEventHarmonized(InteractionEvent.FEATURE_DISPLAYED, {
    h_event_category_006: InteractionEvent.FEATURE_DISPLAYED,
    h_event_action_007: InteractionGoal.DISPLAY_LOGIN_REQUEST,
    h_event_label_008: InteractionEvent.FAVOURITES_ADD,
    h_listing_advertisement_id_120: listingId,
  });
}

export function trackLoginSuccessfulRedirection(loggedInUser: UserLoginInfo | undefined): void {
  trackEventHarmonized(InteractionEvent.AUTHENTICATION, {
    h_event_category_006: InteractionEvent.AUTHENTICATION,
    h_event_action_007: AuthEventAction.LOGIN,
    h_event_label_008: InteractionEvent.FAVOURITES_ADD,
    h_login_location_049: EventLocation.FAVOURITES,
    h_client_login_provider_034: loggedInUser?.loginProvider,
    h_login_status_035: AuthEventStatus.CLIENT_LOGIN,
    h_client_login_user_id_036: loggedInUser?.userId,
  });
}
